import React, {useEffect, useState} from "react";
import ErrorView from "../../common/ErrorView";
import Loading from "../../common/Loading";
import FeedMigrationView from "./migration-components/FeedMigrationView";
import FeedMigrationConfirmationView from "./migration-components/FeedMigrationConfirmationView";
import {api} from "../../Dependencies";
import * as PropTypes from "prop-types";
import {getDecodedValue, redirectTo} from "../../common/utils";

function MigrateFinaliseContainer({authCode, consentId, migrationApplicationData, error}) {
  const [isLoading, setLoading] = useState(true);
  const [accountData, setAccountData] = useState({});
  const [migratedResult, setMigratedResult] = useState({});
  const [selectedBankAccounts, setSelectedBankAccounts] = useState({});
  const [selectedCreditCards, setSelectedCreditCards] = useState({});
  const [isFeedMigrated, setFeedMigrated] = useState(false)
  const [errorType, setErrorType] = useState(null);

  useEffect(() => {
    const getFeedAccountDetails = async () => {
      try {
        const data = await api.fetchAccountDataForMigration(authCode, migrationApplicationData, consentId);
        setAccountData(data);
        setLoading(false);
      } catch (err) {
        err.status === 409 ? setErrorType('applicationCannotProceed') : setErrorType('applicationFailed');
      }
    }

    const declineApplication = async () => {
      try {
        await api.updateApplicationStatus(getDecodedValue("applicationId", migrationApplicationData), "ConsentDeclined");
        setErrorType('accountsNotConnected');
      } catch {
        setErrorType('applicationFailed');
      }
    }

    error ? declineApplication() : getFeedAccountDetails();
  }, []);

  const handleRedirect = () => {
    redirectTo(accountData.productRedirectUrl)
  }

  const setResultAndSelections = ({migratedResult, bankAccountSelections, creditCardSelections}) => {
    setMigratedResult(migratedResult)
    setSelectedBankAccounts(bankAccountSelections)
    setSelectedCreditCards(creditCardSelections)
  }

  const isFromBNZ = () => getDecodedValue("source", migrationApplicationData)?.toLowerCase() === "ProprietaryAPI".toLowerCase();

  const renderFeedMigrationView = () => <FeedMigrationView accountData={accountData} isLoading={isLoading} setLoading={setLoading} setFeedMigrated={setFeedMigrated} isFromBNZ={isFromBNZ()} setErrorType={setErrorType} handleRedirect={handleRedirect} setResultAndSelections={setResultAndSelections}/>

  const renderFeedMigrationConfirmationView = () => <FeedMigrationConfirmationView accountData={accountData} selectedBankAccounts={selectedBankAccounts} selectedCreditCards={selectedCreditCards} migratedResult={migratedResult} setMigratedResult={setMigratedResult} setErrorType={setErrorType} handleRedirect={handleRedirect} />

  return (
    <div>
      {
        errorType ? <ErrorView type={errorType} redirectUrl={getDecodedValue("productRedirectUrl", migrationApplicationData)}/> :
          isLoading ?
            <Loading message={"Fetching your feed info..."}/> :
            !isFeedMigrated ? renderFeedMigrationView() : renderFeedMigrationConfirmationView()
      }
    </div>
  )
}
MigrateFinaliseContainer.propTypes = {
  authCode: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  consentId: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  migrationApplicationData: PropTypes.string.isRequired,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};

export default MigrateFinaliseContainer;
